import { MARKETING_STATUS } from 'components/TableCells/MarketingStatusCell';
import { MARKETING_STATUS_LIST } from 'components/TableCells/MarketingStatusCell/helpers';

export { MARKETING_STATUS_LIST };

export const INITIAL_SUBSCRIBED_FILTER_VALUE = [String(MARKETING_STATUS.SUBSCRIBED)];

export const getMarketingStatusListFromState = (state) => {
    return state.serverList?.[MARKETING_STATUS_LIST]?.data || [];
};

export const hasSubscribedFilter = (value) => {
    if (Array.isArray(value)) {
        return value.some((item) => String(item) === String(MARKETING_STATUS.SUBSCRIBED));
    }

    return String(value) === String(MARKETING_STATUS.SUBSCRIBED);
};

export const getSubscribedMarketingStatusOption = (marketingStatusList) => {
    const match = marketingStatusList.find(
        (item) => String(item?.value ?? item?.['-id']) === String(MARKETING_STATUS.SUBSCRIBED),
    );

    if (!match) {
        return null;
    }

    return {
        value: String(match?.value ?? match?.['-id'] ?? MARKETING_STATUS.SUBSCRIBED),
        label: match?.label ?? match?.Label ?? '',
    };
};
